import { IFullContent } from 'Entities/common'

export enum KoreanCultureType {
  ADDITIONAL_LESSON = 'ADDITIONAL_LESSON',
  INTRODUCE_KOREAN_CULTURE = 'INTRODUCE_KOREAN_CULTURE',
  CULTURE_CLASSES = 'CULTURE_CLASSES',
  IN_DEPTH_STUDY = 'IN_DEPTH_STUDY',
}

export interface ICulture extends IFullContent {
  koreanCultureType: KoreanCultureType
}
